import {render} from "../Components/ToastMessage.js";

export const copySwappedContent = () => {
    const content = document.getElementById('clipboard-content');

    navigator.clipboard.writeText(content.textContent);

    content.remove();
};

export const copyText = async (text, label = null) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        return render(document.getElementById('clipboard-failed-toast-message'));
    }

    const template    = document.getElementById('clipboard-toast-message').cloneNode(true);
    const placeholder = template.content.querySelector('b');

    if (label) {
        placeholder.replaceWith(label);
    } else {
        const preview = text.length > 80 ? `${text.slice(0, 80)}…` : text;

        placeholder.textContent = preview;
    }

    render(template);
};
